<template>
  <div>
    <!-- <CartNotice v-if="$store.getters.addedCartNotice" /> -->
    <Product />
  </div>
</template>

<script>
// import CartNotice from '@/components/product/CartNotice'
import Product from '@/components/product/Product'

export default {
  name: 'ProductPage',
  components: { Product },
}
</script>
